// import api from './api';
import { apiUtils } from '../utils/api';

// Fetch all clients
export const getClientList = async () => {
  return await apiUtils.get('clients/');
};

export const getClientDetail = async (id) => {
  if (!id) {
    throw new Error('Client ID is required');
  }
  return await apiUtils.get(`clients/${id}/`);
};

// Update a client
export const updateClient = async (id, data) => {
  try {
    const payload = { ...data };
    delete payload.user;
    delete payload.client_id;
    delete payload.id;

    console.log('[updateClient payload]', payload);

    const response = await apiUtils.put(`clients/${id}/`, payload);
    return response.data;
  } catch (error) {
    console.error('[updateClient ERROR]', error.response?.data || error.message);
    throw error;
  }
};

// Delete a client
export const deleteClient = async (id) => {
  return await apiUtils.delete(`clients/${id}/`);
};

// -------------------------------
// SUBSCRIPTION
// -------------------------------

/**
 * Subscribe a user to a plan.
 * @param {number} planId - The ID of the plan to subscribe to.
 */
export const subscribeClient = async (planId) => {
  try {
    console.log('[subscribeClient DEBUG] Sending:', { plan: planId });
    const data = await apiUtils.post('subscribe/', { plan_id: planId });
    return data;
  } catch (error) {
    console.error('[subscribeClient ERROR]', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Fetch the current user's subscription
 */
export const getMySubscription = async () => {
  try {
    const data = await apiUtils.get('my-subscription/');
    console.log("SUBSCRIPTION RESPONSE:", data);
    return data;
  } catch (error) {
    console.error('[getMySubscription ERROR]', error.response?.data || error.message);
    throw error;
  }
};

export const getPlans = async () => {
  try {
    const data = await apiUtils.get('plans/');
    console.log("PLANS RESPONSE:", data);
    return data;
  } catch (error) {
    console.error('[getPlans ERROR]', error.response?.data || error.message);
    throw error;
  }
};

export const requestSubscriptionCancellation = async () => {
  try {
    return await apiUtils.post('request-subscription-cancellation/', {});
  } catch (error) {
    console.error('[requestSubscriptionCancellation ERROR]', error.response?.data || error.message);
    throw error;
  }
};

export const getCancellationRequests = async () => {
  try {
    const data = await apiUtils.get('cancellation-requests/');
    return Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('[getCancellationRequests ERROR]', error.response?.data || error.message);
    throw error;
  }
};

export const approveCancellationRequest = async (requestId) => {
  try {
    return await apiUtils.post(`cancellation-requests/${requestId}/approve/`);
  } catch (error) {
    console.error('[approveCancellationRequest ERROR]', error.response?.data || error.message);
    throw error;
  }
};

export const denyCancellationRequest = async (requestId) => {
  try {
    return await apiUtils.post(`cancellation-requests/${requestId}/deny/`);
  } catch (error) {
    console.error('[denyCancellationRequest ERROR]', error.response?.data || error.message);
    throw error;
  }
};

// -------------------------------
// PROFILE
// -------------------------------

export const getMyProfile = async () => {
  try {
    return await apiUtils.get('my-profile/');
  } catch (error) {
    console.error('[getMyProfile ERROR]', error.response?.data || error.message);
    throw error;
  }
};

